import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import InputNumberNoScroll from "../../../../../components/inputs/inputNumberNoScroll";

export default function CrearMoneda({
  onClose = () => {},
  onCreated = () => {},
}) {
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");
  const [valorCambio, setValorCambio] = useState("");
  const [codigoIso, setCodigoIso] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = codigo.trim() !== "" && nombre.trim() !== "";

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = {
        codigo: codigo.trim(),
        nombre: nombre.trim(),
        valorCambio: valorCambio ? Number(valorCambio) : null,
        codigoIso: codigoIso ? Number(codigoIso) : null,
      };
      const created = await appFetchJson(apiRoutes.monedas.create, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando moneda:", e);
      setError(e?.message || "Ocurrió un error al guardar la moneda.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Moneda</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Introduzca los datos de la nueva moneda
          </p>
          {error && (
            <div className="text-red-600 mb-3 font-medium">{error}</div>
          )}
          <div className="space-y-4">
            <div>
              <label className="form-label">Código *</label>
              <input
                type="text"
                className="input"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value)}
                placeholder="Código de la moneda"
              />
            </div>
            <div>
              <label className="form-label">Descripción *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre de la moneda"
              />
            </div>
            <div>
              <label className="form-label">Valor Cambio</label>
              <InputNumberNoScroll
                step="1"
                className="input"
                value={valorCambio}
                onChange={(e) =>
                  setValorCambio(
                    e.target.value === "" ? "" : Number(e.target.value),
                  )
                }
                placeholder="Valor de cambio"
              />
            </div>
            <div>
              <label className="form-label">Código ISO</label>
              <InputNumberNoScroll
                step="1"
                className="input"
                value={codigoIso}
                onChange={(e) =>
                  setCodigoIso(
                    e.target.value === "" ? "" : Number(e.target.value),
                  )
                }
                placeholder="Código ISO"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid}
              saving={saving}
              onClick={guardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}
